import{cloneDeepWith as o}from"./cloneDeepWith.js";function r(e){return o(e)}export{r as cloneDeep};
